import React, {useEffect, useState} from "react";
import {LoggedInView} from "../common/LoggedInView";
import {Link, useParams} from "react-router-dom";
import {useAppDispatch, useAppSelector} from "../../utils/Hooks";
import {getClients} from "../../store/reducers/ClientsSlice";
import {InquirySearch} from "./components/InquiriesSearch";
import {InquiriesTable} from "./components/InquiriesTable";
import {getInquiries} from "../../store/reducers/InquiriesSlice";
import InquiryTabs from "./components/InquiryTabs";
import Pagination from "../common/Pagination";
import DraftsTable from "./components/DraftsTable";
import {RequestStatus} from "../../utils/Enums";

interface InquiriesScreenProps {
}

export const InquiriesScreen: React.FC<InquiriesScreenProps> = () => {

    const dispatch = useAppDispatch();
    const routeParams = useParams();

    const inquiriesState = useAppSelector((state) => state.inquiries);

    const tab:string|null = new URLSearchParams(window.location.search).get('tab');
    const perPage = parseInt(new URLSearchParams(window.location.search).get('perPage') || '80', 10);

    const totalItems =
        tab === 'answered' ? inquiriesState.countAnswered :
        tab === 'drafts' ? inquiriesState.countDrafts :
        inquiriesState.countUnanswered;

    useEffect(() => {
        dispatch(getInquiries());
    }, [routeParams]);

    return (
        <LoggedInView fullWidth={false}>
            <InquirySearch />
            <InquiryTabs />
            {inquiriesState.getInquiriesStatus === RequestStatus.Loading ? (
                <div style={{ marginTop: 50, fontStyle: 'italic' }}><br />Laen andmeid…</div>
            ) : (
                tab === 'drafts' ? <DraftsTable /> : <InquiriesTable />
            )}
            {inquiriesState.getInquiriesStatus != RequestStatus.Loading && <Pagination totalItems={totalItems} itemsPerPage={perPage} />}
        </LoggedInView>
    )

}